import { Link } from 'react-router-dom';
import { useState } from 'react';
import { useSEO, generateCourseSchema, generateBreadcrumbSchema, generateWebPageSchema } from '../../utils/seo';

export default function Egitimlerimiz() {
  const [selectedMonth, setSelectedMonth] = useState('nisan');

  // SEO Configuration
  useSEO({
    title: 'Eğitim Programları | Osmaniye İlkyardım, Yüksekte Çalışma, Yangın Eğitimi - ASSA Akademi',
    description: 'Osmaniye eğitim programları: Sağlık Bakanlığı onaylı ilkyardım eğitimi, IRATA LEVEL 3 yüksekte çalışma güvenliği, yangın söndürme, hijyen eğitimi ve MYK belgelendirme. Profesyonel sertifika alın.',
    keywords: 'Osmaniye ilkyardım eğitimi programı, yüksekte çalışma eğitimi Osmaniye, IRATA LEVEL 3 sertifika, yangın güvenliği kursu, hijyen eğitimi sertifikası, İSG temel eğitimi, MYK danışmanlığı Osmaniye, iş güvenliği sertifikası',
    canonical: '/egitimlerimiz',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        generateBreadcrumbSchema([
          { name: 'Ana Sayfa', url: '/' },
          { name: 'Eğitimlerimiz', url: '/egitimlerimiz' }
        ]),
        generateWebPageSchema('Eğitim Programları', 'Osmaniye ilkyardım eğitimi, yüksekte çalışma ve iş güvenliği sertifika programları', '/egitimlerimiz'),
        generateCourseSchema(
          'Temel İlkyardım Eğitimi',
          'Osmaniye\'de 16 saatlik Sağlık Bakanlığı onaylı temel ilkyardım eğitimi. CPR, yaralanmalar, kırıklar, zehirlenmeler ve acil durumlar.',
          'P2D',
          '450'
        ),
        generateCourseSchema(
          'Yüksekte Çalışma Eğitimi - IRATA LEVEL 3',
          'Osmaniye\'de 16 saatlik yüksekte çalışma güvenliği eğitimi. IRATA LEVEL 3 sertifikalı eğitmenler tarafından verilen emniyet kemeri, ip erişim teknikleri ve güvenlik prosedürleri eğitimi.',
          'P2D'
        ),
        generateCourseSchema(
          'Yangın Güvenliği Eğitimi',
          'Osmaniye\'de 8 saatlik yangın güvenliği eğitimi. Yangın söndürme teknikleri, tahliye prosedürleri ve acil durum yönetimi.',
          'P1D'
        ),
        generateCourseSchema(
          'İSG Temel Eğitimi',
          'Osmaniye\'de İş Sağlığı ve Güvenliği temel eğitimi. İş kazalarını önleme, risk değerlendirmesi ve güvenli çalışma yöntemleri.',
          'P2D'
        )
      ]
    }
  });

  const months = [
    { key: 'nisan', name: 'Nisan 2026' },
    { key: 'mayis', name: 'Mayıs 2026' },
    { key: 'haziran', name: 'Haziran 2026' },
    { key: 'temmuz', name: 'Temmuz 2026' }
  ];

  const schedules = {
    nisan: [
      { type: 'İSG Temel Eğitimi', spots: 21 },
      { type: 'İlkyardım Eğitimi', spots: 21 },
      { type: 'Yüksekte Çalışma Eğitimi', spots: 21 },
      { type: 'Yangın Eğitimi', spots: 21 }
    ],
    mayis: [
      { type: 'İSG Temel Eğitimi', spots: 21 },
      { type: 'Acil Durum Eğitimleri', spots: 21 },
      { type: 'Meslek Eğitimi ve MYK', spots: 21 },
      { type: 'İlkyardım Eğitimi', spots: 21 }
    ],
    haziran: [
      { type: 'Yüksekte Çalışma Eğitimi', spots: 21 },
      { type: 'Yangın Eğitimi', spots: 21 },
      { type: 'İSG Temel Eğitimi', spots: 21 },
      { type: 'Acil Durum Eğitimleri', spots: 21 }
    ],
    temmuz: [
      { type: 'Meslek Eğitimi ve MYK', spots: 21 },
      { type: 'İlkyardım Eğitimi', spots: 21 },
      { type: 'İSG Temel Eğitimi', spots: 21 },
      { type: 'Yüksekte Çalışma Eğitimi', spots: 21 }
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-lg sticky top-0 z-50">
        <div className="container mx-auto px-6">
          <div className="flex justify-between items-center py-4">
            <Link to="/" className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/69983b9b992309f9f345f22b715baa7c/d976ad48ea6e824eb2b305836503c616.jfif" 
                alt="ASSA Logo" 
                className="h-12 w-auto"
              />
            </Link>
            <div className="hidden md:flex space-x-8">
              <Link to="/" className="text-gray-700 hover:text-blue-600 cursor-pointer">Ana Sayfa</Link>
              <Link to="/egitimlerimiz" className="text-blue-600 font-semibold cursor-pointer">Eğitimlerimiz</Link>
              <Link to="/hakkimizda" className="text-gray-700 hover:text-blue-600 cursor-pointer">Hakkımızda</Link>
              <Link to="/sss" className="text-gray-700 hover:text-blue-600 cursor-pointer">SSS</Link>
              <Link to="/iletisim" className="text-gray-700 hover:text-blue-600 cursor-pointer">İletişim</Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section
        className="relative h-[60vh] bg-cover bg-center bg-no-repeat flex items-center"
        style={{
          backgroundImage:
            "linear-gradient(rgba(37, 99, 235, 0.85), rgba(37, 99, 235, 0.7)), url('https://public.readdy.ai/ai/img_res/94c9a50260601c08ffc6d95105d45b43.jpg')"
        }}
      >
        <div className="container mx-auto px-6 text-white">
          <div className="max-w-3xl">
            <h1 className="text-5xl font-bold mb-6">Eğitim Programlarımız</h1>
            <p className="text-xl mb-8 leading-relaxed">
              Sağlık Bakanlığı onaylı temel ilkyardım eğitimi, yüksekte çalışma güvenliği, yangın eğitimi, hijyen eğitimi ve mesleki eğitim programları. Osmaniye\'de profesyonel sertifika eğitimleri.
            </p>
          </div>
        </div>
      </section>

      {/* Programs Overview */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">Eğitim Türlerimiz</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              İhtiyaçlarınıza uygun eğitim programları ile profesyonel sertifikanızı alın
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-8 mb-16">
            {/* İSG Temel Eğitimi */}
            <div className="bg-white rounded-xl shadow-lg overflow-hidden h-full flex flex-col">
              <div
                className="h-48 bg-cover bg-center"
                style={{
                  backgroundImage:
                    "url('https://readdy.ai/api/search-image?query=Occupational%20health%20and%20safety%20training%20session%20with%20workers%20wearing%20safety%20helmets%20and%20vests%2C%20professional%20workplace%20safety%20instructor%20demonstrating%20safety%20procedures%2C%20modern%20industrial%20training%20facility%20with%20safety%20equipment%20and%20clean%20professional%20environment&width=400&height=300&seq=isg-training&orientation=landscape')"
                }}
              ></div>
              <div className="p-8 flex flex-col flex-1">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-shield-check-line text-xl text-white"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-800">İSG Temel Eğitimi</h3>
                </div>
                <p className="text-gray-600 mb-6 leading-relaxed flex-1">
                  İş Sağlığı ve Güvenliği temel eğitimi. İş kazalarını önleme, risk değerlendirmesi,
                  güvenli çalışma yöntemleri ve yasal yükümlülükler.
                </p>
                <div className="space-y-3 mb-6">
                  <div className="flex items-center">
                    <i className="ri-time-line text-blue-600 mr-3"></i>
                    <span className="text-gray-700">16 Saat (2 Gün)</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-award-line text-blue-600 mr-3"></i>
                    <span className="text-gray-700">İSG Sertifikası</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-group-line text-blue-600 mr-3"></i>
                    <span className="text-gray-700">Maksimum 20 Kişi</span>
                  </div>
                </div>
                <div className="text-center mt-auto">
                  <Link 
                    to="/iletisim"
                    className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer inline-block"
                  >
                    Kayıt Ol
                  </Link>
                </div>
              </div>
            </div>

            {/* Yüksekte Çalışma Eğitimi */}
            <div className="bg-white rounded-xl shadow-lg overflow-hidden h-full flex flex-col">
              <div
                className="h-48 bg-cover bg-center"
                style={{
                  backgroundImage:
                    "url('https://readdy.ai/api/search-image?query=Height%20safety%20training%20with%20professional%20safety%20equipment%2C%20workers%20learning%20to%20use%20safety%20harnesses%20and%20ropes%2C%20industrial%20safety%20education%20with%20safety%20gear%20demonstration%2C%20clean%20professional%20training%20environment&width=400&height=300&seq=height-safety-training&orientation=landscape')"
                }}
              ></div>
              <div className="p-8 flex flex-col flex-1">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-orange-600 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-building-2-line text-xl text-white"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-800">Yüksekte Çalışma</h3>
                </div>
                <p className="text-gray-600 mb-6 leading-relaxed flex-1">
                  16 saatlik yüksekte çalışma güvenliği eğitimi. <strong className="text-orange-700">IRATA LEVEL 3 sertifikalı eğitmenler</strong> tarafından verilen emniyet kemeri kullanımı,
                  ip erişim teknikleri ve düşme önleme sistemleri eğitimi.
                </p>
                <div className="space-y-3 mb-6">
                  <div className="flex items-center">
                    <i className="ri-time-line text-orange-600 mr-3"></i>
                    <span className="text-gray-700">16 Saat (2 Gün)</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-award-line text-orange-600 mr-3"></i>
                    <span className="text-gray-700">Yüksekte Çalışma Sertifikası</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-user-star-line text-orange-600 mr-3"></i>
                    <span className="text-gray-700">IRATA LEVEL 3 Eğitmenler</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-group-line text-orange-600 mr-3"></i>
                    <span className="text-gray-700">Maksimum 15 Kişi</span>
                  </div>
                </div>
                <div className="text-center mt-auto">
                  <Link 
                    to="/iletisim"
                    className="bg-orange-600 hover:bg-orange-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer inline-block"
                  >
                    Kayıt Ol
                  </Link>
                </div>
              </div>
            </div>

            {/* Yangın Eğitimi */}
            <div className="bg-white rounded-xl shadow-lg overflow-hidden h-full flex flex-col">
              <div
                className="h-48 bg-cover bg-center"
                style={{
                  backgroundImage:
                    "url('https://readdy.ai/api/search-image?query=Fire%20safety%20training%20with%20fire%20extinguishers%2C%20professional%20firefighting%20equipment%20demonstration%2C%20emergency%20response%20training%20in%20industrial%20safety%20facility%2C%20clean%20professional%20environment&width=400&height=300&seq=fire-safety-training&orientation=landscape')"
                }}
              ></div>
              <div className="p-8 flex flex-col flex-1">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-fire-line text-xl text-white"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-800">Yangın Eğitimi</h3>
                </div>
                <p className="text-gray-600 mb-6 leading-relaxed flex-1">
                  8 saatlik yangın güvenliği eğitimi. Yangın söndürme teknikleri,
                  tahliye prosedürleri ve acil durum yönetimi.
                </p>
                <div className="space-y-3 mb-6">
                  <div className="flex items-center">
                    <i className="ri-time-line text-red-600 mr-3"></i>
                    <span className="text-gray-700">8 Saat (1 Gün)</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-award-line text-red-600 mr-3"></i>
                    <span className="text-gray-700">Yangın Güvenliği Sertifikası</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-group-line text-red-600 mr-3"></i>
                    <span className="text-gray-700">Maksimum 20 Kişi</span>
                  </div>
                </div>
                <div className="text-center mt-auto">
                  <Link 
                    to="/iletisim"
                    className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer inline-block"
                  >
                    Kayıt Ol
                  </Link>
                </div>
              </div>
            </div>

            {/* Acil Durum Eğitimleri */}
            <div className="bg-white rounded-xl shadow-lg overflow-hidden h-full flex flex-col">
              <div
                className="h-48 bg-cover bg-center"
                style={{
                  backgroundImage:
                    "url('https://readdy.ai/api/search-image?query=Emergency%20response%20training%20with%20professional%20rescue%20equipment%2C%20emergency%20medical%20services%20training%2C%20disaster%20preparedness%20education%20in%20modern%20training%20facility%2C%20clean%20professional%20environment&width=400&height=300&seq=emergency-training&orientation=landscape')"
                }}
              ></div>
              <div className="p-8 flex flex-col flex-1">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-yellow-600 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-alarm-warning-line text-xl text-white"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-800">Acil Durum Eğitimleri</h3>
                </div>
                <p className="text-gray-600 mb-6 leading-relaxed flex-1">
                  Kapsamlı acil durum müdahale eğitimi. Afet yönetimi, tahliye planları,
                  kriz yönetimi ve acil eylem planları.
                </p>
                <div className="space-y-3 mb-6">
                  <div className="flex items-center">
                    <i className="ri-time-line text-yellow-600 mr-3"></i>
                    <span className="text-gray-700">12 Saat (2 Gün)</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-award-line text-yellow-600 mr-3"></i>
                    <span className="text-gray-700">Acil Durum Sertifikası</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-group-line text-yellow-600 mr-3"></i>
                    <span className="text-gray-700">Maksimum 18 Kişi</span>
                  </div>
                </div>
                <div className="text-center mt-auto">
                  <Link 
                    to="/iletisim"
                    className="bg-yellow-600 hover:bg-yellow-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer inline-block"
                  >
                    Kayıt Ol
                  </Link>
                </div>
              </div>
            </div>

            {/* İlkyardım Eğitimi */}
            <div className="bg-white rounded-xl shadow-lg overflow-hidden h-full flex flex-col">
              <div
                className="h-48 bg-cover bg-center"
                style={{
                  backgroundImage:
                    "url('https://readdy.ai/api/search-image?query=First%20aid%20training%20session%20with%20instructor%20demonstrating%20CPR%20techniques%20on%20medical%20training%20mannequin%2C%20students%20observing%20closely%20in%20bright%20medical%20classroom%2C%20professional%20medical%20education%20setting%20with%20clean%20white%20background%20and%20medical%20equipment&width=400&height=300&seq=firstaid-training-card&orientation=landscape')"
                }}
              ></div>
              <div className="p-8 flex flex-col flex-1">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-heart-pulse-line text-xl text-white"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-800">İlkyardım Eğitimi</h3>
                </div>
                <p className="text-gray-600 mb-6 leading-relaxed flex-1">
                  16 saatlik kapsamlı temel ilkyardım eğitimi. CPR, yaralanmalar, kırıklar,
                  zehirlenmeler ve acil durumlar.
                </p>
                <div className="space-y-3 mb-6">
                  <div className="flex items-center">
                    <i className="ri-time-line text-green-600 mr-3"></i>
                    <span className="text-gray-700">16 Saat (2 Gün)</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-award-line text-green-600 mr-3"></i>
                    <span className="text-gray-700">Sağlık Bakanlığı Sertifikası</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-group-line text-green-600 mr-3"></i>
                    <span className="text-gray-700">Maksimum 20 Kişi</span>
                  </div>
                </div>
                <div className="text-center mt-auto">
                  <Link 
                    to="/iletisim"
                    className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer inline-block"
                  >
                    Kayıt Ol
                  </Link>
                </div>
              </div>
            </div>

            {/* Meslek Eğitimi ve MYK */}
            <div className="bg-white rounded-xl shadow-lg overflow-hidden h-full flex flex-col">
              <div
                className="h-48 bg-cover bg-center"
                style={{
                  backgroundImage:
                    "url('https://readdy.ai/api/search-image?query=Professional%20vocational%20training%20classroom%20with%20modern%20equipment%2C%20skilled%20workers%20learning%20technical%20skills%2C%20industrial%20education%20and%20certification%20programs%2C%20clean%20professional%20environment&width=400&height=300&seq=vocational-myk-training&orientation=landscape')"
                }}
              ></div>
              <div className="p-8 flex flex-col flex-1">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-purple-600 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-file-shield-line text-xl text-white"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-800">Meslek Eğitimi ve MYK</h3>
                </div>
                <p className="text-gray-600 mb-6 leading-relaxed flex-1">
                  Mesleki Yeterlilik Kurumu süreçleri. Belgelendirme, yetkinlik danışmanlığı
                  ve sektörel mesleki eğitimler.
                </p>
                <div className="space-y-3 mb-6">
                  <div className="flex items-center">
                    <i className="ri-time-line text-purple-600 mr-3"></i>
                    <span className="text-gray-700">Esnek Süre</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-award-line text-purple-600 mr-3"></i>
                    <span className="text-gray-700">MYK Sertifikası</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-group-line text-purple-600 mr-3"></i>
                    <span className="text-gray-700">Maksimum 25 Kişi</span>
                  </div>
                </div>
                <div className="text-center mt-auto">
                  <Link 
                    to="/iletisim"
                    className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer inline-block"
                  >
                    Kayıt Ol
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Monthly Schedule */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">Aylık Ders Programı</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Size uygun tarihleri seçin ve eğitiminize hemen başlayın
            </p>
          </div>

          {/* Month Selector */}
          <div className="flex justify-center mb-12">
            <div className="bg-gray-100 rounded-full p-2 flex space-x-2">
              {months.map((month) => (
                <button
                  key={month.key}
                  onClick={() => setSelectedMonth(month.key)}
                  className={`px-6 py-3 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
                    selectedMonth === month.key
                      ? 'bg-blue-600 text-white'
                      : 'text-gray-600 hover:text-blue-600 hover:bg-white'
                  }`}
                >
                  {month.name}
                </button>
              ))}
            </div>
          </div>

          {/* Schedule Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-6">
            {schedules[selectedMonth as keyof typeof schedules].map((course, index) => (
              <div key={index} className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-6 border border-blue-200">
                <div className="flex justify-between items-start mb-4">
                  <div>
                    <h3 className="text-xl font-bold text-gray-800 mb-2">{course.type}</h3>
                  </div>
                </div>

                <div className="flex justify-between items-center pt-4 border-t border-blue-200">
                  <div className="flex items-center">
                    <i className="ri-user-line text-blue-600 mr-2"></i>
                    <span className="text-gray-700">{course.spots} Kontenjan</span>
                  </div>
                  <Link
                    to="/iletisim"
                    className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Kayıt Ol
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-blue-600 to-blue-800 text-white">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold mb-6">Hemen Başvurun</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto leading-relaxed">
            Size en uygun tarihi seçin ve profesyonel eğitimi tamamlayın.
            Sertifikanızı alarak iş güvenliği ve sağlık konusunda uzmanlaşın.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/iletisim"
              className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              Hemen Kayıt Ol
            </Link>
            <Link
              to="/hakkimizda"
              className="bg-transparent border-2 border-white hover:bg-white hover:text-blue-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              Hakkımızda
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-16">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <p className="text-gray-300 leading-relaxed mb-6">
                Sağlık Bakanlığı onaylı ilkyardım eğitimleri ile hayat kurtarmayı öğrenin.
              </p>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-6">Hızlı Linkler</h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/" className="text-gray-300 hover:text-white cursor-pointer">
                    Ana Sayfa
                  </Link>
                </li>
                <li>
                  <Link to="/egitimlerimiz" className="text-gray-300 hover:text-white cursor-pointer">
                    Eğitimlerimiz
                  </Link>
                </li>
                <li>
                  <Link to="/hakkimizda" className="text-gray-300 hover:text-white cursor-pointer">
                    Hakkımızda
                  </Link>
                </li>
                <li>
                  <Link to="/iletisim" className="text-gray-300 hover:text-white cursor-pointer">
                    İletişim
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-6">Eğitimler</h4>
              <ul className="space-y-3">
                <li>
                  <span className="text-gray-300">İSG Temel Eğitimi</span>
                </li>
                <li>
                  <span className="text-gray-300">Yüksekte Çalışma</span>
                </li>
                <li>
                  <span className="text-gray-300">Yangın Eğitimi</span>
                </li>
                <li>
                  <span className="text-gray-300">İlkyardım Eğitimi</span>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-6">İletişim</h4>
              <div className="space-y-3">
                <div className="flex items-center">
                  <i className="ri-phone-line text-blue-400 mr-3"></i>
                  <span className="text-gray-300">0850 346 2772</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-mail-line text-blue-400 mr-3"></i>
                  <span className="text-gray-300">info@assaakademi.com.tr</span>
                </div>
                <div className="flex items-start">
                  <i className="ri-map-pin-line text-blue-400 mr-3 mt-1"></i>
                  <span className="text-gray-300">Adnan Menderes, Emniyet Cd. 28/B, 80010 Osmaniye Merkez/Osmaniye</span>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-700 pt-8 mt-12">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p className="text-gray-400 mb-4 md:mb-0">
                © 2024 Assa İş Eğitimleri Akademisi. Tüm hakları saklıdır.
              </p>
            </div>
          </div>
        </div>
      </footer>

      {/* WhatsApp Button */}
      <div className="fixed bottom-6 right-6 z-50">
        <a
          href="https://wa.me/+905324196401"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-green-500 hover:bg-green-600 text-white w-16 h-16 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 animate-pulse cursor-pointer"
          title="WhatsApp ile iletişime geç"
        >
          <i className="ri-whatsapp-line text-2xl"></i>
        </a>
      </div>
    </div>
  );
}
